import type { ReactNode } from "react";
import Link from "@/components/ui/link-compat";

interface LinkedRecordCardProps {
  icon: ReactNode;
  title: string;
  name: string;
  subtitle?: string;
  href: string;
}

export function LinkedRecordCard({ icon, title, name, subtitle, href }: LinkedRecordCardProps) {
  return (
    <div className="rounded-[10px] border bg-card px-3 pb-3 pt-2.5">
      <div className="mb-2 font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">
        {title}
      </div>
      <Link href={href} className="flex items-center gap-2.5">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
          {icon}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-[13px] font-medium">{name}</span>
          {subtitle && (
            <span className="block truncate text-[11px] text-muted-foreground">{subtitle}</span>
          )}
        </span>
      </Link>
    </div>
  );
}
